import { ClientRemoteServiceEntity, ClientSiteEntity } from '@edgebox/api-rest-client';
import React from 'react';
import { Alert, Container } from 'react-bootstrap';
import { ApiComponent, IApiComponentState, SiteSelector, SyncCoreSelector } from '../../../common';
import { ContentBox } from '../../Shared/ContentBox';
import { Embed } from '../../Shared/Embed';
import { SiteApplicationType } from '@edgebox/sync-core-data-definitions';

interface IState extends IApiComponentState {
  syncCore?: ClientRemoteServiceEntity;
}

export class BackendFormulaPlayground extends ApiComponent<{}, IState> {
  async load(): Promise<Partial<IState>> {
    return {};
  }

  render() {
    const { syncCore } = this.state;

    return (
      <Container>
        <h1>Formula playground</h1>
        <p className="text-muted">Live validation and preview are executed against the selected Sync Core.</p>

        <ContentBox>
          <SyncCoreSelector
            appType={SiteApplicationType.SyncCore}
            value={syncCore}
            emptyLabel={'Select Sync Core'}
            onSelected={(s) => this.selectSyncCore(s)}
            onRemove={() => this.selectSyncCore(undefined)}
          />
        </ContentBox>

        {syncCore ? (
          <ContentBox>
            <Embed embed="formula" scope="configuration" syncCore={syncCore} options={{}} />
          </ContentBox>
        ) : (
          <Alert variant="light">Select a Sync Core to start.</Alert>
        )}
      </Container>
    );
  }

  private selectSyncCore(syncCore?: ClientRemoteServiceEntity) {
    this.setState({ syncCore });
  }
}
